/* cvn-peek.js — the engine behind <cvn-peek>, the foot-of-page LAYOUT PEEK
   (sections/cvn-layout-peek.liquid on niche / vibe / group / vibe-category pages, and
   sections/cvn-type-peek.liquid on type pages, curated lists and the Shop All / Vibes hubs).

   WHY A CUSTOM ELEMENT. The theme navigates by swapping #MainContent without running the
   incoming markup's <script> tags, so a script inside the peek section would be dead after any
   in-site navigation. A custom element needs no script at insertion time: once the class is
   defined (this file is loaded globally from the header's cvn-view-toggle section), the browser
   upgrades every <cvn-peek> it meets and calls connectedCallback, whatever put it in the page.
   disconnectedCallback clears the timers when a swap removes it.

   WHAT IT DOES — a faithful miniature of collection-designs' behaviour, same timings:
     · hero auto-rotation every 5s through the cards' lifestyle photos (single hero on desktop,
       the two-photo TWIN on portrait phones, exactly like the gallery)
     · card hover (pointer devices): the card zooms per blank (same ZOOM table), cycles its
       colours every 1.4s with the size badge on mugs, and the hero shows THAT design's photos
       every 3.5s; leaving restores everything and resumes the rotation
     · touch (phones): the card under the finger activates, like the gallery
     · parent pages (group / vibe-category / type / hub): the hero title + link follow the
       hovered card's row
   And for the GRID peek (data-peek="grid"): the grid is shown at the shopper's own cards-per-row
   density (the same cvn_dens_p / cvn_dens_d cookies cvn-filter.js keeps, same per-device ranges and
   defaults), two rows deep, and the "cards per row" control in its toolbar is real: the same slider
   popover, writing the same cookie, so the real grid opens the way the shopper set it here.

   BREAKDOWN (the type peek). The breakdown gallery is cut by a choice remembered on the device —
   localStorage cvn_type_breakdown: 'collections' (the groups) or a vibe category's handle — so:
     · gallery peek with data-bd="1": one .cvn-pk-dim[data-cat] per breakdown; the remembered one
       shows, its compact "Browse by ▾" switches (and remembers) exactly like the real bar, and a
       hub's dims marked data-lazy are fetched from sections/cvn-shopall-vibes on first need and
       prefetched once the page has settled. Rows arriving in the gallery's own .cvn-type-sec
       markup are rebuilt into .cvn-pk-row (three rows, four cards, a "+N View all" card).
     · grid peek with data-chipsets="1": one .cvn-peek-chips[data-cat] per breakdown; the
       remembered one shows, and the gallery's dropdown (type-designs) announces a change on
       window as 'cvn:breakdown' so the chips below follow it live.
   Never touches the header toggle; the "Switch to …" links are handled by that script. */
(function () {
  if (!window.customElements || customElements.get('cvn-peek')) return;

  var ZOOM_DEFAULT = { ox: 50, oy: 35, sc: 1.6 };
  var ZOOM_BY_CATALOG = {
    71:   { ox: 50, oy: 11, sc: 1.59 },
    145:  { ox: 52, oy: 13, sc: 1.59 },
    294:  { ox: 50, oy: 8,  sc: 1.57 },
    367:  { ox: 49, oy: 80, sc: 1.75 },
    1553: { ox: 50, oy: 74, sc: 1.92 },
    19:   { byLabel: { '11 oz': { ox: 31, oy: 57, sc: 1.44 }, '15 oz': { ox: 27, oy: 54, sc: 1.35 }, '20 oz': { ox: 13, oy: 57, sc: 1.36 } } },
    300:  { byLabel: { '11 oz': { ox: 28, oy: 55, sc: 1.42 }, '15 oz': { ox: 24, oy: 56, sc: 1.35 } } }
  };
  function zoomFor(catalog, label) {
    var z = ZOOM_BY_CATALOG[catalog];
    if (!z) return ZOOM_DEFAULT;
    if (z.byLabel) { return (label && z.byLabel[label]) || z.byLabel[Object.keys(z.byLabel)[0]] || ZOOM_DEFAULT; }
    return z;
  }
  function pairsOf(card) {
    return (card.getAttribute('data-hero-pairs') || card.getAttribute('data-ha') || '')
      .split('|||').filter(Boolean).map(function (p) { var x = p.split(','); return [x[0], x[1] || x[0]]; });
  }
  function makeHeroItem(card) {
    var pairs = pairsOf(card);
    var L = pairs.map(function (p) { return p[0]; });
    var R = pairs.map(function (p) { return p[1]; });
    var all = L.concat(R), n = L.length, off = n > 1 ? 1 : 0;
    return {
      pairs: pairs, all: all, niche: card.getAttribute('data-niche'), nicheUrl: card.getAttribute('data-niche-url'),
      frameSingle: function (a) { return all[((a % all.length) + all.length) % all.length]; },
      frameTwin: function (a) { return [L[((a % n) + n) % n], R[(((a + off) % n) + n) % n]]; }
    };
  }
  /* crossfade between two stacked <img> layers; safe when the target is already loaded */
  function fader(nodes) {
    var c = 0, inited = nodes.length && nodes[0].classList.contains('on') && nodes[0].getAttribute('src');
    return function (url) {
      if (!url || !nodes.length) return;
      if (nodes.length < 2) { nodes[0].src = url; nodes[0].classList.add('on'); return; }
      if (!inited) { nodes[0].src = url; nodes[0].classList.add('on'); inited = true; return; }
      if (nodes[c].getAttribute('src') === url) return;
      var n = 1 - c, nl = nodes[n];
      var done = function () { nl.onload = null; nl.classList.add('on'); nodes[c].classList.remove('on'); c = n; };
      if (nl.getAttribute('src') === url && nl.complete) { done(); }
      else { nl.onload = done; nl.src = url; if (nl.complete && nl.naturalWidth) { done(); } }
    };
  }
  /* the remembered breakdown: 'collections' or a vibe-category handle */
  function savedBd() { try { return localStorage.getItem('cvn_type_breakdown') || ''; } catch (e) { return ''; } }
  function saveBd(v) { try { localStorage.setItem('cvn_type_breakdown', v); } catch (e) {} }
  function announceBd(v, src) { try { window.dispatchEvent(new CustomEvent('cvn:breakdown', { detail: { bd: v, source: src } })); } catch (e) {} }

  /* rows served in the gallery's own markup (.cvn-type-sec, from snippets/cvn-vibe-rows or the
     lazy section) → the peek's .cvn-pk-row: three rows, four cards, the rest folded into one
     "+N View all" card that keeps the row's own link */
  function adoptRows(dim, rowcap, cardcap) {
    var secs = Array.prototype.slice.call(dim.querySelectorAll('.cvn-type-sec'));
    if (!secs.length) return;
    var frag = document.createDocumentFragment(), n = 0;
    secs.forEach(function (sec) {
      if (n >= rowcap) return;
      var cards = Array.prototype.slice.call(sec.querySelectorAll('.cvn-dcard'));
      if (!cards.length) return;
      var h = sec.querySelector('.cvn-type-h'), lnk = h ? h.querySelector('a') : null;
      var row = document.createElement('div'); row.className = 'cvn-pk-row' + (n === 0 ? ' is-first' : '');
      var p = document.createElement('p'); p.className = 'cvn-pk-row-h'; p.innerHTML = h ? h.innerHTML : ''; row.appendChild(p);
      var car = document.createElement('div'); car.className = 'cvn-carousel';
      cards.slice(0, cardcap).forEach(function (c) { car.appendChild(c); });
      var va = sec.querySelector('.cvn-viewall'), vaN = 0;
      if (va) { var t = (va.querySelector('.cvn-viewall-n') || {}).textContent || ''; vaN = parseInt(t.replace(/[^0-9]/g, ''), 10) || 0; }
      var more = Math.max(0, cards.length - cardcap) + vaN;
      if (more > 0) {
        var a = document.createElement('a'); a.className = 'cvn-viewall';
        a.setAttribute('href', (va && va.getAttribute('href')) || (lnk && lnk.getAttribute('href')) || '#');
        a.setAttribute('aria-label', 'View all ' + (h ? h.textContent.trim() : ''));
        a.innerHTML = '<span class="cvn-viewall-in"><span class="cvn-viewall-n">+' + more + '</span><span class="cvn-viewall-t">View all &rsaquo;</span></span>';
        car.appendChild(a);
      }
      row.appendChild(car); frag.appendChild(row); n++;
    });
    dim.innerHTML = ''; dim.appendChild(frag);
  }
  /* product links in a vibe breakdown carry ?bd=<category> so the product breadcrumb keeps the vibe path (as the gallery does) */
  function stampBd(dim) {
    var cat = dim.getAttribute('data-cat'); if (!cat || cat === 'collections') return;
    /* ⚠ BOTH SELECTORS, AND THAT IS NOT BELT-AND-BRACES. The design card became a
       DIV with a full-cover `.cvn-dcard-link` when Quick view landed on it, so
       `a.cvn-dcard` now matches NOTHING — and this function fails silently: the
       cards still render, still link, and only the `?bd=` that keeps the vibe path
       in the product breadcrumb quietly stops being written. Matching both shapes
       means neither form of the card can break it. */
    dim.querySelectorAll('a.cvn-dcard, a.cvn-dcard-link').forEach(function (a) {
      var href = a.getAttribute('href') || ''; if (!href || href.indexOf('bd=') > -1) return;
      a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + 'bd=' + cat);
    });
  }

  var portraitMq = window.matchMedia('(orientation: portrait) and (max-aspect-ratio: 3/4)');

  class CvnPeek extends HTMLElement {
    connectedCallback() {
      if (this.__booted) return;
      /* ALWAYS SHOWN. An earlier version hid the peek for the rest of the tab session once the
         shopper had switched layouts themselves — it had done its teaching job. That reasoning only
         holds for someone who came to learn the toggle exists; for a SCROLLER the peek is the offer
         itself, waiting at the foot of every browse page, and a shopper who tried the other layout
         once is exactly the one most likely to want it again. */
      this.__booted = true; this.__timers = []; this.__cleanup = []; this.boot();
    }
    disconnectedCallback() { this.teardown(); this.__booted = false; }
    every(fn, ms) { var t = setInterval(fn, ms); this.__timers.push(t); return t; }
    clear(t) { clearInterval(t); }
    teardown() {
      (this.__timers || []).forEach(clearInterval); this.__timers = [];
      (this.__cleanup || []).forEach(function (f) { try { f(); } catch (e) {} }); this.__cleanup = [];
    }
    boot() {
      var kind = this.getAttribute('data-peek');
      var src = this.getAttribute('data-peek-src');
      if (src) { this.hydrate(src, kind); return; }
      if (kind === 'grid') { this.bootGrid(); return; }
      if (kind === 'gallery') { this.bootGallery(); }
    }
    /* PAST PAGE 1 the section ships this frame EMPTY, because Liquid's paginate opens at the page in
       the URL and every row would render its heading with no cards. The contents come from the same
       section rendered at page 1 (data-peek-src = <collection>?section_id=<this instance>), which is
       what a shopper on page 1 sees — the peek is a teaser, not a view of the current page. A frame
       that cannot be filled hides its whole section rather than sitting there empty. */
    hydrate(src, kind) {
      var self = this;
      var drop = function () { var sec = self.closest('.cvn-peek'); if (sec) sec.hidden = true; };
      fetch(src, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('cvn-peek[data-peek="' + kind + '"]');
          if (!el || !el.children.length) { drop(); return; }
          ['data-parent', 'data-bd', 'data-default-bd', 'data-noun', 'data-chipsets'].forEach(function (a) {
            if (el.hasAttribute(a)) self.setAttribute(a, el.getAttribute(a));
          });
          self.removeAttribute('data-peek-src');
          self.innerHTML = el.innerHTML;
          if (kind === 'grid') self.bootGrid(); else self.bootGallery();
        })
        .catch(drop);
    }

    /* ===== GRID peek: the shopper's own density, and a working "cards per row" control =====
       Mirrors cvn-filter.js exactly: cookie cvn_dens_p (phones, 1–3, default 2) / cvn_dens_d
       (desktop, 3–6 capped by what fits at ~166px a card, default 4). Reading it means the peek
       shows the grid the way THIS shopper last had it; the slider writes the same cookie, so a
       change made here is what the real grid opens with. Two rows × n cards are shown. */
    bootGrid() {
      var root = this, self = this;
      var grid = root.querySelector('.cvn-peek-grid'); if (!grid) return;
      var items = Array.prototype.slice.call(grid.children);
      var btn = root.querySelector('.cvn-pk-dens-btn'), pop = root.querySelector('.cvn-pk-dens-pop');
      var pill = root.querySelector('.cvn-pk-dens-pill'), cap = root.querySelector('.cvn-pk-dens-cap');
      var rng = root.querySelector('.cvn-pk-dens-range'), lo = root.querySelector('.cvn-pk-dens-lo'), hi = root.querySelector('.cvn-pk-dens-hi');
      var noun = root.getAttribute('data-noun') || 'products';
      function phone() { return window.matchMedia('(max-width: 749px)').matches; }
      function range() {
        if (phone()) return { key: 'p', min: 1, max: 3, def: 2 };
        var w = Math.round(root.getBoundingClientRect().width) - 28;   /* screen px: the frame is zoomed */
        var fit = w > 0 ? Math.floor((w - 16) / 166) : 6;
        var max = Math.max(3, Math.min(6, fit));
        return { key: 'd', min: 3, max: max, def: max >= 4 ? 4 : max };
      }
      function saved(key) { var m = document.cookie.match(new RegExp('(?:^|;\\s*)cvn_dens_' + key + '=([0-9]+)')); return m ? parseInt(m[1], 10) : 0; }
      function squares(n) {
        var gap = 2, w = (24 - gap * (n - 1)) / n, s = '';
        for (var i = 0; i < n; i++) s += '<rect x="' + (i * (w + gap)).toFixed(2) + '" y="0" width="' + w.toFixed(2) + '" height="8" rx="1"></rect>';
        return '<svg width="24" height="8" viewBox="0 0 24 8" fill="currentColor" aria-hidden="true">' + s + '</svg>';
      }
      function apply(n, save) {
        var r = range();
        n = Math.max(r.min, Math.min(r.max, n));
        grid.style.setProperty('--pk-cols', n);
        grid.classList.add('is-set');
        for (var i = 0; i < items.length; i++) { items[i].hidden = i >= 2 * n; }
        if (pill) pill.innerHTML = squares(n);
        if (cap) cap.textContent = n + ' ' + (n === 1 ? noun.replace(/s$/, '') : noun) + ' per row';
        if (rng) { rng.min = r.min; rng.max = r.max; rng.value = n; }
        if (lo) lo.innerHTML = squares(r.min);
        if (hi) hi.innerHTML = squares(r.max);
        if (save) { document.cookie = 'cvn_dens_' + r.key + '=' + n + ';path=/;max-age=' + (3600 * 24 * 30) + ';samesite=lax'; }
      }
      function current() { var r = range(); var c = saved(r.key); return c ? c : r.def; }
      apply(current(), false);
      if (btn && pop) {
        var open = function (on) { pop.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false'); };
        btn.addEventListener('click', function (e) { e.stopPropagation(); open(!pop.classList.contains('is-open')); });
        pop.addEventListener('click', function (e) { e.stopPropagation(); });
        var onDoc = function () { open(false); };
        document.addEventListener('click', onDoc);
        self.__cleanup.push(function () { document.removeEventListener('click', onDoc); });
        if (rng) { rng.addEventListener('input', function () { apply(parseInt(rng.value, 10), true); }); }
      }
      var onResize = function () { apply(current(), false); };
      window.addEventListener('resize', onResize);
      self.__cleanup.push(function () { window.removeEventListener('resize', onResize); });

      /* breakdown chip sets (the type peek): show the remembered breakdown's members; follow the gallery's dropdown */
      if (root.getAttribute('data-chipsets') === '1') {
        var sets = Array.prototype.slice.call(root.querySelectorAll('.cvn-peek-chips[data-cat]'));
        if (sets.length) {
          var defBd = root.getAttribute('data-default-bd') || 'collections';
          var has = function (v) { return sets.some(function (s) { return s.getAttribute('data-cat') === v && s.children.length > 0; }); };
          var showSet = function (v) {
            if (!v || !has(v)) v = has(defBd) ? defBd : sets[0].getAttribute('data-cat');
            sets.forEach(function (s) { s.hidden = s.getAttribute('data-cat') !== v; });
          };
          showSet(savedBd() || defBd);
          var onBd = function (e) { showSet(e && e.detail && e.detail.bd); };
          window.addEventListener('cvn:breakdown', onBd);
          self.__cleanup.push(function () { window.removeEventListener('cvn:breakdown', onBd); });
        }
      }
    }

    /* ===== GALLERY peek: the miniature of collection-designs with its motion ===== */
    bootGallery() {
      var root = this, self = this;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var PARENT = root.getAttribute('data-parent') === '1';
      var titleEls = root.querySelectorAll('.cvn-pk-title');
      var heroLinks = root.querySelectorAll('.cvn-pk-hero-link');
      function setLabel(t) { if (!PARENT || !t) return; for (var i = 0; i < titleEls.length; i++) titleEls[i].textContent = t; }
      function setHref(u) { if (!PARENT || !u) return; for (var i = 0; i < heroLinks.length; i++) heroLinks[i].setAttribute('href', u); }

      /* hero items, interleaved across the VISIBLE rows like the gallery (a hidden breakdown's rows are skipped) */
      var heroItems = [];
      function collectHero() {
        var arr = [];
        var secs = Array.prototype.filter.call(root.querySelectorAll('.cvn-pk-row'), function (s) { var d = s.closest('.cvn-pk-dim'); return !(d && d.hidden); });
        var lists = secs.map(function (sec) {
          return Array.prototype.filter.call(sec.querySelectorAll('.cvn-dcard'), function (c) { return c.getAttribute('data-hero-pairs') || c.getAttribute('data-ha'); });
        });
        var max = 0; lists.forEach(function (l) { if (l.length > max) max = l.length; });
        for (var r = 0; r < max; r++) for (var t = 0; t < lists.length; t++) { var c = lists[t][r]; if (c) arr.push(makeHeroItem(c)); }
        return arr;
      }

      var single = fader(root.querySelectorAll('.cvn-pk-hl'));
      var lFade = fader(root.querySelectorAll('.cvn-pk-tl-l .cvn-pk-tl'));
      var rFade = fader(root.querySelectorAll('.cvn-pk-tl-r .cvn-pk-tl'));
      function twinVisible() { return portraitMq.matches; }
      function showItem(it, a) {
        if (twinVisible()) { var lr = it.frameTwin(a); lFade(lr[0]); rFade(lr[1]); }
        else { single(it.frameSingle(a)); }
        setLabel(it.niche); setHref(it.nicheUrl);
      }

      var active = false, ai = 0, auto = null;
      function startAuto() { if (reduce || heroItems.length < 2 || auto) return; auto = self.every(function () { if (active) return; ai++; var len = heroItems.length; showItem(heroItems[ai % len], Math.floor(ai / len)); }, 5000); }
      function stopAuto() { if (auto) { self.clear(auto); auto = null; } }

      function makeCtl(card) {
        var catalog = parseInt(card.getAttribute('data-catalog'), 10) || 0;
        var colors = (card.getAttribute('data-colors') || '').split('|||').filter(Boolean);
        var labels = (card.getAttribute('data-color-labels') || '').split('|||');
        var badge = card.querySelector('.cvn-size-badge');
        var clayers = card.querySelectorAll('.cvn-clayer');
        var ccur = 0, orig = clayers.length ? clayers[0].getAttribute('src') : null, preloaded = false;
        var hT = null, cT = null;
        function setBadge(i) { if (!badge) return; if (labels[i]) { badge.textContent = labels[i]; badge.classList.add('on'); } else { badge.classList.remove('on'); } }
        function setZoom(label, on) { var z = zoomFor(catalog, label); for (var k = 0; k < clayers.length; k++) { clayers[k].style.transformOrigin = z.ox + '% ' + z.oy + '%'; clayers[k].style.transform = on ? ('scale(' + z.sc + ')') : ''; } }
        function swap(url, label) {
          if (!url || clayers.length < 2) return; if (clayers[ccur].getAttribute('src') === url) return;
          var nxt = 1 - ccur, nl = clayers[nxt];
          if (label != null) { var z = zoomFor(catalog, label); var pt = nl.style.transition; nl.style.transition = 'none'; nl.style.transformOrigin = z.ox + '% ' + z.oy + '%'; nl.style.transform = 'scale(' + z.sc + ')'; void nl.offsetWidth; nl.style.transition = pt; }
          function show() { nl.onload = null; nl.classList.add('on'); clayers[ccur].classList.remove('on'); ccur = nxt; }
          if (nl.getAttribute('src') === url && nl.complete) { show(); } else { nl.onload = show; nl.src = url; if (nl.complete && nl.naturalWidth) show(); }
        }
        function preload() { if (!preloaded) { colors.forEach(function (u) { var im = new Image(); im.src = u; }); preloaded = true; } }
        function startColors() { preload(); if (colors.length > 1 && !reduce) { if (cT) self.clear(cT); var ci = 0; setBadge(0); setZoom(labels[0] || '', true); cT = self.every(function () { ci = (ci + 1) % colors.length; swap(colors[ci], labels[ci] || ''); setBadge(ci); }, 1400); } }
        function stopColors() { if (cT) { self.clear(cT); cT = null; } if (orig) swap(orig); if (badge) badge.classList.remove('on'); setZoom(labels[0] || '', false); }
        return {
          el: card,
          on: function () {
            active = true; card.classList.add('cvn-active'); setLabel(card.getAttribute('data-niche')); setHref(card.getAttribute('data-niche-url')); setZoom(labels[0] || '', true); startColors();
            if (hT) self.clear(hT);
            var pairs = pairsOf(card); if (!pairs.length) return;
            var hi = 0;
            function heroStep() { var p = pairs[hi % pairs.length]; if (twinVisible()) { lFade(p[0]); rFade(p[1]); } else { var flat = pairs.map(function (q) { return q[0]; }).concat(pairs.map(function (q) { return q[1]; })); single(flat[hi % flat.length]); } hi++; }
            heroStep();
            if (!reduce) { hT = self.every(heroStep, 3500); }
          },
          off: function () { active = false; card.classList.remove('cvn-active'); if (hT) { self.clear(hT); hT = null; } stopColors(); startAuto(); }
        };
      }
      var activeCtl = null;
      function bindCards(scope) {
        Array.prototype.forEach.call(scope.querySelectorAll('.cvn-dcard'), function (card) {
          if (card.__cvnPk) return;
          var c = makeCtl(card); card.__cvnPk = c;
          if (canHover) {
            card.addEventListener('mouseenter', function () { stopAuto(); c.on(); });
            card.addEventListener('mouseleave', function () { c.off(); });
          }
        });
      }
      bindCards(root);
      if (!canHover) {
        function cardAt(x, y) { var el = document.elementFromPoint(x, y); if (!el || !el.closest) return null; var card = el.closest('.cvn-dcard'); return card && root.contains(card) ? card.__cvnPk : null; }
        function setActive(ctl) { if (!ctl || ctl === activeCtl) return; if (activeCtl) activeCtl.off(); activeCtl = ctl; stopAuto(); ctl.on(); }
        function onTouch(e) { var t = e.touches && e.touches[0]; if (t) setActive(cardAt(t.clientX, t.clientY)); }
        root.addEventListener('touchstart', onTouch, { passive: true });
        root.addEventListener('touchmove', onTouch, { passive: true });
      }
      /* (re)start the hero from the visible rows — at boot, and after a breakdown switch or a lazy arrival */
      function rebuild() {
        if (activeCtl) { activeCtl.off(); activeCtl = null; }
        stopAuto(); active = false; ai = 0;
        heroItems = collectHero();
        if (heroItems.length) showItem(heroItems[0], 0);
        startAuto();
      }
      /* orientation flips: re-show the current frame in whichever hero is now visible */
      var onOrient = function () { if (heroItems.length && !active) showItem(heroItems[ai % heroItems.length], Math.floor(ai / heroItems.length)); };
      if (portraitMq.addEventListener) { portraitMq.addEventListener('change', onOrient); self.__cleanup.push(function () { portraitMq.removeEventListener('change', onOrient); }); }

      /* ===== the breakdown (type peek): dims, the compact dropdown, lazy dims ===== */
      if (root.getAttribute('data-bd') === '1') {
        var ROWCAP = 3, CARDCAP = 4;
        var dims = Array.prototype.slice.call(root.querySelectorAll('.cvn-pk-dim[data-cat]'));
        var defBd = root.getAttribute('data-default-bd') || 'collections';
        var bar = root.querySelector('.cvn-pk-bd'), trigger = root.querySelector('.cvn-pk-bd-trigger'), menu = root.querySelector('.cvn-pk-bd-menu');
        var txt = trigger ? trigger.querySelector('.cvn-pk-bd-txt') : null;
        var opts = menu ? Array.prototype.slice.call(menu.querySelectorAll('.cvn-pk-bd-opt')) : [];
        dims.forEach(function (d) { adoptRows(d, ROWCAP, CARDCAP); stampBd(d); bindCards(d); });
        function dimFor(v) { for (var i = 0; i < dims.length; i++) if (dims[i].getAttribute('data-cat') === v) return dims[i]; return null; }
        function usable(d) { return !!d && (d.querySelector('.cvn-pk-row') || d.hasAttribute('data-lazy')); }
        function optFor(v) { for (var i = 0; i < opts.length; i++) if (opts[i].getAttribute('data-val') === v) return opts[i]; return null; }
        function labelFor(v) { var o = optFor(v); return o ? o.textContent.trim() : (txt ? txt.textContent : ''); }
        /* an empty breakdown (a curated list with no row for it) is not offered */
        opts.forEach(function (o) { if (!usable(dimFor(o.getAttribute('data-val')))) o.hidden = true; });
        function loadLazy(dim, cb) {
          if (!dim || dim.__loaded || dim.__loading) { if (cb) cb(); return; }
          var url = dim.getAttribute('data-lazy'); if (!url) { if (cb) cb(); return; }
          dim.__loading = true;
          dim.innerHTML = '<div class="cvn-pk-wait">Loading…</div>';
          fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var rows = doc.querySelector('.cvn-lazy-rows');
            dim.innerHTML = rows ? rows.innerHTML : '';
            dim.__loaded = true; dim.__loading = false; dim.removeAttribute('data-lazy');
            adoptRows(dim, ROWCAP, CARDCAP); stampBd(dim); bindCards(dim);
            if (!usable(dim)) { var o = optFor(dim.getAttribute('data-cat')); if (o) o.hidden = true; }
            if (!dim.hidden) rebuild();
            if (cb) cb();
          }).catch(function () { dim.__loading = false; dim.innerHTML = ''; if (cb) cb(); });
        }
        function setBd(v, remember) {
          if (!v || v === 'collections') { v = dimFor('collections') ? 'collections' : defBd; }
          var d = dimFor(v);
          if (!usable(d)) { v = defBd; d = dimFor(v); }
          if (!usable(d)) { v = dims.length ? dims[0].getAttribute('data-cat') : v; d = dimFor(v); }
          dims.forEach(function (x) { x.hidden = x !== d; });
          if (txt) txt.textContent = labelFor(v);
          opts.forEach(function (o) { o.setAttribute('aria-selected', o.getAttribute('data-val') === v ? 'true' : 'false'); });
          if (d && d.hasAttribute('data-lazy')) loadLazy(d);
          rebuild();
          if (remember) { saveBd(v); announceBd(v, 'peek'); }
        }
        if (trigger && menu) {
          var openMenu = function (on) { menu.hidden = !on; trigger.setAttribute('aria-expanded', on ? 'true' : 'false'); };
          trigger.addEventListener('click', function (e) { e.stopPropagation(); openMenu(menu.hidden); });
          opts.forEach(function (o) { o.addEventListener('click', function (e) { e.stopPropagation(); setBd(o.getAttribute('data-val'), true); openMenu(false); }); });
          var onDocClick = function (e) { if (!menu.hidden && bar && !bar.contains(e.target)) openMenu(false); };
          var onKey = function (e) { if (e.key === 'Escape' || e.keyCode === 27) openMenu(false); };
          document.addEventListener('click', onDocClick); document.addEventListener('keydown', onKey);
          self.__cleanup.push(function () { document.removeEventListener('click', onDocClick); document.removeEventListener('keydown', onKey); });
        }
        setBd(savedBd() || defBd, false);
        /* the gallery's own dropdown (if one is on the page) drives this peek too */
        var onBd = function (e) { if (e && e.detail && e.detail.source !== 'peek') setBd(e.detail.bd, false); };
        window.addEventListener('cvn:breakdown', onBd);
        self.__cleanup.push(function () { window.removeEventListener('cvn:breakdown', onBd); });
        /* prefetch the lazy dims once the page has settled, so the dropdown is usually instant */
        (function () {
          var lazy = dims.filter(function (d) { return d.hasAttribute('data-lazy'); }); if (!lazy.length) return;
          var i = 0;
          function next() { if (i >= lazy.length || !root.isConnected) return; loadLazy(lazy[i++], next); }
          /* rIC with a timeout: a background tab never reports idle, and the prefetch must still happen before the shopper comes back */
          var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
          function start() { setTimeout(function () { idle(next, { timeout: 4000 }); }, 1500); }
          if (document.readyState === 'complete') { start(); } else { window.addEventListener('load', start, { once: true }); }
        })();
      } else {
        rebuild();
      }
    }
  }
  customElements.define('cvn-peek', CvnPeek);
})();
